import { combineReducers } from "redux";
import homePageSliceReducer from "../features/HomePage/HomePageSlice";
import authReducer from "../features/Auth/AuthSlice";
import queueReducer from "../features/Queue/QueueSlice";
import generationReducer from "../features/Generation/GenerationSlice";

export default combineReducers({
  homePageSlice: homePageSliceReducer,
  auth: authReducer,
  queue: queueReducer,
  generation: generationReducer,
});
